__turbopack_context__.v({
  "lds-dual-ring": "_3EeiLq_lds-dual-ring",
  "textsizespinner": "_3EeiLq_textsizespinner",
});
